import { render, staticRenderFns } from "./AdminCampaignList.vue?vue&type=template&id=b84b2a40&scoped=true&"
import script from "./AdminCampaignList.vue?vue&type=script&lang=js&"
export * from "./AdminCampaignList.vue?vue&type=script&lang=js&"
import style0 from "./AdminCampaignList.vue?vue&type=style&index=0&id=b84b2a40&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b84b2a40",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAutocomplete } from 'vuetify/lib'
import { VBtn } from 'vuetify/lib'
import { VCard } from 'vuetify/lib'
import { VLayout } from 'vuetify/lib'
installComponents(component, {
  VAutocomplete,
  VBtn,
  VCard,
  VLayout,
})
